import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface ClipCanvasErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ClipCanvasErrorBoundaryState {
  hasError: boolean;
}

/**
 * 隔离画布渲染异常，避免拖垮主剧集编辑器（FR-046）。
 */
export default class ClipCanvasErrorBoundary extends Component<
  ClipCanvasErrorBoundaryProps,
  ClipCanvasErrorBoundaryState
> {
  constructor(props: ClipCanvasErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ClipCanvasErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ClipInfiniteCanvas 渲染失败:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="clip-canvas-error-boundary">
            画布渲染出现问题，已停止以保护编辑器。请关闭后重试。
          </div>
        )
      );
    }
    return this.props.children;
  }
}
